import { render, staticRenderFns } from "./ContentEditor.vue?vue&type=template&id=5ff2a25b&scoped=true&"
import script from "./ContentEditor.vue?vue&type=script&lang=js&"
export * from "./ContentEditor.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditor.vue?vue&type=style&index=0&id=5ff2a25b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff2a25b",
  null
  
)

export default component.exports